import React, { useState } from "react";
import { FormGroup, Button, Container, Input, Label } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { CreateCacelation } from "../../apis/CancelationPolicy";
import { AxiosError } from "axios";

const AddCancelationPolicy = () => {
  const [isChecked, setIsChecked] = useState(true);
  const [cancelationName, setCancelationName] = useState({
    en: "",
    ar: "",
  });
  const [cancelationContent, setCancelationContent] = useState({
    en: "",
    ar: "",
  });
  const navigate = useNavigate();

  const breadcrumbItems = [
    { title: "Dashboard", link: "/" },
    { title: "Cancelation Policy", link: "#" },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await CreateCacelation(
        cancelationName,
        cancelationContent,
        isChecked ? "enabled" : "disabled",
      );
      if (response) {
        toast.success("Cancelation Type Created Successfully");
        navigate("/cancelation-policy");
      } else {
        toast.error("Cancelation Type Creation Failed");
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An unexpected error occurred. Please try again later.");
      }
    }
  };
  return (
    <React.Fragment>
      <div className="page-content">
      <Container className="px-0 dark:bg-darkBg1 dark:text-[#c7d8eb]" fluid>
        <Breadcrumbs
          title="Add Cancelation Type"
          breadcrumbItems={breadcrumbItems}
        />
        <div className="p-6 flex flex-col gap-6 ">
          <h1 className="text-2xl dark:text-[#c7d8eb]">Add Cancelation Type</h1>
          <div className="lg:flex flex-col w-full lg:max-w-4xl mx-auto p-4 lg:rounded-lg lg:border border-gray-400 dark:border-white">
            <AvForm onValidSubmit={handleSubmit}>
              <div className="mb-3">
                <AvField
                  className="dark:!bg-darkBg1 dark:!text-[#c7d8eb] dark:!border-white dark:placeholder:!text-[#c7d8eb]"
                  name="itemNameEn"
                  label="Cancelation Type Name In English"
                  placeholder="Type cancelation name In English"
                  type="text"
                  errorMessage="Enter Cancelation Type Name In English"
                  validate={{ required: { value: true } }}
                  value={cancelationName.en}
                  onChange={(e) =>
                    setCancelationName({
                      ...cancelationName,
                      en: e.target.value,
                    })
                  }
                />
              </div>
              <div className="mb-3">
                <AvField
                  className="dark:!bg-darkBg1 dark:!text-[#c7d8eb] dark:!border-white dark:placeholder:!text-[#c7d8eb]"
                  name="itemNameAr"
                  label="Cancelation Type Name In Arabic"
                  placeholder="Type cancelation name In Arabic"
                  type="text"
                  errorMessage="Enter Cancelation Type Name In Arabic"
                  validate={{ required: { value: true } }}
                  value={cancelationName.ar}
                  onChange={(e) =>
                    setCancelationName({
                      ...cancelationName,
                      ar: e.target.value,
                    })
                  }
                />
              </div>
              <div className="mb-3">
                <AvField
                  className="dark:!bg-darkBg1 min-h-5 max-h-32 dark:!text-[#c7d8eb] dark:!border-white dark:placeholder:!text-[#c7d8eb]"
                  name="itemContentEn"
                  label="Cancelation Type Description In English"
                  placeholder="Type cancelation description In English"
                  type="textarea"
                  errorMessage="Enter Cancelation Type Description In English"
                  validate={{ required: { value: true } }}
                  value={cancelationContent.en}
                  onChange={(e) =>
                    setCancelationContent((prev) => ({
                      ...prev,
                      en: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="mb-3">
                <AvField
                  className="dark:!bg-darkBg1 min-h-5 max-h-32 dark:!text-[#c7d8eb] dark:!border-white dark:placeholder:!text-[#c7d8eb]"
                  name="itemContentAr"
                  label="Cancelation Type Description In Arabic"
                  placeholder="Type cancelation description In Arabic"
                  type="textarea"
                  errorMessage="Enter Cancelation Type Description In Arabic"
                  validate={{ required: { value: true } }}
                  value={cancelationContent.ar}
                  onChange={(e) =>
                    setCancelationContent((prev) => ({
                      ...prev,
                      ar: e.target.value,
                    }))
                  }
                />
              </div>
              <h4 className="text-base dark:text-[#c7d8eb]">Status</h4>
              <div className="form-check form-switch mb-3" dir="ltr">
                <Input
                  type="checkbox"
                  className="form-check-input"
                  checked={isChecked}
                  onChange={() => setIsChecked((prev) => !prev)} // Toggle the state on change
                  id="customSwitch1"
                  defaultChecked
                />

                <Label className="form-check-label" htmlFor="customSwitch1">
                  {isChecked ? "Active" : "Inactive"}
                </Label>
              </div>
              <FormGroup className="mb-0">
                <div>
                  <Button type="submit" color="primary" className="me-1">
                    Add
                  </Button>{" "}
                  <Button
                    type="button"
                    color="secondary"
                    onClick={() => {
                      setCancelationName("");
                      setCancelationContent("");
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </FormGroup>
            </AvForm>
          </div>
        </div>
      </Container>
      </div>
    </React.Fragment>
  );
};

export default AddCancelationPolicy;
